import breakpoints from './breakpoints';

export default {
  'bp-small': window.matchMedia(`(min-width: ${breakpoints['bp-small']}px)`),
  'bp-medium': window.matchMedia(`(min-width: ${breakpoints['bp-medium']}px)`),
  'bp-large': window.matchMedia(`(min-width: ${breakpoints['bp-large']}px)`),
  'bp-x-large': window.matchMedia(`(min-width: ${breakpoints['bp-x-large']}px)`),
};
